import AccountService from "../../services/AccountService";
import BaseService from "../../services/BaseService";
import UserService from "../../services/UserService";

export default {
    state: {
        accounts: [],
        users: [],
    },
    getters: {
        accounts: state => {
            return state.accounts;
        },
        users: state => {
            return state.users;
        }
    },
    mutations: {
        SET_ACCOUNTS(state, accounts) {
            state.accounts = accounts;
        },
        SET_USERS(state, users) {
            state.users = users;
        }
    },
    actions: {
        loadUsers( { state, commit }, force = false) {
            if (force || !state.users.length) {
                UserService.index().then((result) => {
                    if (result.status === BaseService.STATUS_200) {
                        commit('SET_USERS', result.data);
                    }
                });
            }
        },
        loadAccounts( { state, commit }, force = false) {
            if (force || !state.accounts.length) {
                AccountService.index().then((result) => {
                    if (result.status === BaseService.STATUS_200) {
                        commit('SET_ACCOUNTS', result.data);
                    }
                });
            }
        },
        createAccount( { dispatch }, data) {
            return AccountService.createAccount(data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadAccounts', true);
                }
            });
        },
        updateAccount( { dispatch }, params) {
            return AccountService.updateAccount(params.id, params.data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadAccounts', true);
                }
            });
        },
        deleteAccount( { dispatch }, id) {
            return AccountService.deleteAccount(id).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadAccounts', true);
                }
            });
        },
        addUserToAccount( { dispatch }, data) {
            return AccountService.addUserToAccount(data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadAccounts', true);
                }
            });
        },
        deleteUserFromAccount( { dispatch }, id) {
            return AccountService.deleteUserFromAccount(id).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadAccounts', true);
                }
            });
        },
    },
}